<template>
  <div>
    <v-row v-for="(approver, index) in approvers" :key="index" class="px-3">
      <v-col cols="2" class="pt-2 py-0 px-0">
        <span class="fs-16 lightblack--text">Approver {{ index + 1 }}</span>
      </v-col>
      <v-col cols="5" class="py-0">
        <ValidationProvider
          name="Approver Name"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            id="version"
            single-line
            outlined
            dense
            :items="approverList"
            placeholder="Approver Name"
            v-model="approver.approver_id"
            item-text="desc"
            item-value="id"
            required
            hide-details
            :error-messages="errors"
            :disabled="isDetail"
          />
          <v-checkbox
            v-model="approver.skip_waiting_restriction"
            label="Skip Waiting Restriction"
            dense
            class="mt-0"
            :disabled="isDetail"
          ></v-checkbox>
        </ValidationProvider>
      </v-col>
      <v-col cols="auto" class="pl-0 py-0 pr-1">
        <v-btn
          :disabled="isDetail"
          color="green"
          class="mt-1 white--text"
          @click="addRow(index)"
          ><v-icon>add</v-icon></v-btn
        >
      </v-col>
      <v-col cols="auto" v-if="index !== 0" class="pl-0 py-0 pr-1">
        <v-btn
          :disabled="isDetail"
          color="red"
          class="mt-1 white--text"
          @click="removeRow(index)"
          ><v-icon>delete_outline</v-icon></v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    approvers: {
      type: Array
    },
    approverList: {
      type: Array
    },
    isDetail: {
      type: Boolean
    },
    groupList: {
      type: Object
    },
    panel: {
      type: Number
    },
    parentPanel: {
      type: Number
    },
    panelBo: {
      type: Number,
      require: false
    },
    isBo: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    addRow(index) {
      if (this.isBo) {
        return this.groupList.condition[this.parentPanel].group[
          this.panel
        ].budgetOwner[this.panelBo].profile.approvers.splice(index + 1, 0, {
          approver_id: null,
          approval_level: index + 2,
          skip_waiting_restriction: false
        });
      } else {
        return this.groupList.condition[this.parentPanel].group[
          this.panel
        ].approvers.splice(index + 1, 0, {
          approver_id: null,
          approval_level: index + 2,
          skip_waiting_restriction: false
        });
      }
    },
    removeRow(index) {
      if (this.isBo) {
        return this.groupList.condition[this.parentPanel].group[
          this.panel
        ].budgetOwner[this.panelBo].profile.approvers.splice(index, 1);
      } else {
        return this.groupList.condition[this.parentPanel].group[
          this.panel
        ].approvers.splice(index, 1);
      }
    }
  }
};
</script>
